export const SOFTLINE_API_MDE_WARENVERPROBUNG_BEWEGUNGEN = '/v1/warenverprobung/bewegung/entities'
export const SOFTLINE_API_MDE_WARENVERPROBUNG_ABSCHLUSS = '/v1/warenverprobung/abschluss'
export const SOFTLINE_API_MDE_WARENVERPROBUNG = '/v1/warenverprobung'
export const SOFTLINE_API_MDE_WARENVERPROBUNG_FIND_BELEG = '/v1/warenverprobung/beleg'
export const SOFTLINE_API_MDE_WARENVERPROBUNG_ARTIKEL = '/v1/warenverprobung/artikel/entities'
export const SOFTLINE_API_MDE_WARENVERPROBUNG_ARTIKEL_DETAIL = 'detail'
export const SOFTLINE_API_MDE_WARENVERPROBUNG_ITEM_SCAN = '/v1/warenverprobung/scan/{{type}}/{{code}}'
